import { fromJS } from 'immutable';
import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { data }) =>
  state.setIn(['driver', 'completedOrders'], fromJS(data));

export const setCompletedOrders = createAction({
  action: ['setCompletedOrders', 'data'],
  handler,
});
